import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
// import moment from 'moment';
import { getEntityByOwners, getEntityYears } from 'http/UAM/userDashboardWidget.helper';
import ReactApexChart from 'react-apexcharts';
import 'react-datepicker/dist/react-datepicker.css';

const GetEntityByOwners = () => {
  const [entityData, setEntityData] = useState([]);
  const [roleName, setRoleName] = useState();

  useEffect(() => {
    fetchData();
  }, [roleName]);

  const fetchData = async () => {
    try {
      const roleNameToQuery = roleName || 'RM';
      const entityResponse = await getEntityByOwners({ roleName: roleNameToQuery });
      if (entityResponse.status) {
        setEntityData(entityResponse.data);
      } else {
        setEntityData([]);
      }
    } catch (error) {
      setEntityData([]);
    }
  };

  const xAxisData = entityData?.map((entity) => `${entity.first_name} ${entity.last_name? entity.last_name : ""}`) || [];
  while (xAxisData.length < 6) {
    xAxisData.push(' ');
  }

  const options = {
    toolbar: {
      show: true,
      tools: {
        download: false,
      },
    },
    chart: {
      type: 'bar',
      height: entityData.length > 6 ? entityData.length * 50 : 320, // 70px per item, 6 items max visible
    },
    plotOptions: {
      bar: {
        horizontal: true,
        endingShape: 'flat',
        barHeight: '50%',
        columnWidth: '50%',
        borderRadius: 0,
        dataLabels: {
          position: 'center',
        },
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        const colors = [
          'rgb(52, 195, 143)',
          'rgb(85, 110, 230)',
          'rgb(244, 106, 106)',
          '#f1b44c',
          '#50a5f1',
          '#0174BE',
        ];
        return colors[dataPointIndex] || '#0174BE';
      },
    ],
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    xaxis: {
      title: {
        text: 'Deals',
      },
      categories: xAxisData,
      labels: {
        style: {
          fontSize: '12px',
          maxWidth: 150,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        tooltip: {
          enabled: true,
        },
      },
    },
    yaxis: {},
    fill: {
      opacity: 2,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} Deals`,
      },
    },
  };

  const series = [
    {
      name: '',
      data: entityData?.map((entity) => parseInt(entity.dealsCount, 10)),
    },
  ];
  const handleFilterChange = (e) => {
    setRoleName(e.target.value);
  };
  const formatLenderName = (type) => {
    if (!type) return type;
    return type
      .split('_') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' '); 
  };

  return (
    <Card>
      <CardBody>
        <Row className='mb-2 custom-border'>
          <Col lg='6' sm='12' md='6'>
            <h4 className='card-title mb-2 custom-title'>Deals By Owners - {formatLenderName(roleName) || 'RM'}s</h4>
          </Col>

          <Col lg='6' sm='12' md='6' className="mb-2 custom-select-wrapper">
            <select
              className="form-select"
              id="filterOptions"
              value={roleName}
              onChange={handleFilterChange}
              style={{ width: '95%', marginLeft: "5%" }}
            >
              <option value="RM">RM</option>
              <option value="FI_RM">FI RM</option>
              <option value="program_manager">Program Manager</option>
            </select>
          </Col>
        </Row>
        <div style={{ maxWidth: '100%', maxHeight: '320px' }} className='vertical-scroll'>
          <style>
            {`
              ::-webkit-scrollbar {
                width: 6px;
              }
              ::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
              div::-webkit-scrollbar {
                width: 6px;
              }
              div::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
              }
              div::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
              }
              div::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
            `}
          </style>
          <ReactApexChart
            options={options}
            series={series}
            type='bar'
            height={entityData.length > 6 ? entityData.length * 50 : 320}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default GetEntityByOwners;


